export interface InfosVaccinateurType {
	numAM: string;
	nom: string;
	prenom: string;
}

export enum PrescripteurType {
	psConnecte = 'PSCONNECTE',
	psAutre = 'PSAUTRE'
}

// Model cible
export interface Ps {
	psId: number | undefined;
	amFiness: string;
	rpps: string;
	nom: string;
	prenom: string;
	categorie: string;
	specialite: string;
	organismeRattachement: string;
	informationContact: string;
	origineDonnees: string;
}

export interface PrescriptionType {
	prescriptionId: number | undefined;
	datePrescription: string;
	horodateEnregistrement: string;
	accordPatient: boolean;
	accordCgu: boolean;
	majDossierVacc: string;
	etatDossierVacc: string;
	etapeInjection: number;
	prochaineInjection: string;
	nbInjectionsPrevues: number;
	prescripteur: Ps;
	enregistreur: Ps;
	prescriptEnregistreur: boolean;
	vaccinsPrescrits: VaccinsPrescritsType[];
	vaccinsContreIndiques: VaccinsContreIndiquesType[];
	injections: InjectionType[];
	horodateEnregistrementMaj: string | undefined;
	topEnregistrementMaj: boolean;
	nbInjectionsSupp: number | undefined;
	psDelegation: Ps | null;
	clotureReprises: ClotureRepriseType[];
}

export interface ClotureRepriseType {
	clotureRepriseId: number;
	ps: Ps;
	action: ClotureRepriseAction;
	psDelegation: Ps;
	horodatage: string;
}

export enum ClotureRepriseAction {
	ANNULATION = 'ANNULATION',
	CLOTURE = 'CLOTURE',
	REOUVERTURE = 'REOUVERTURE',
	REACTIVATION = 'REACTIVATION'
}

export interface MotifAnnulation {
	motifId: number;
	code: string;
	libelle: string;
	affichable: boolean;
	revocationUvci: boolean;
}

export interface MotifInjectionSupp {
	motifId: number;
	code: string;
	libelle: string;
}

export interface InjectionType {
	vaccinateur: Ps;
	injectionId: number | undefined;
	prescriptionId: number;
	dateRealisation: string;
	dateEnregistrement: string;
	numeroLot: string;
	rangVaccinal: number;
	horaireVaccination: string;
	siteInjection: string;
	voieAdministration: string;
	finess: string;
	siret: string;
	codeEtablissement: string;
	codePostal: string;
	accordConditionTransmission: boolean;
	dateProchaineInjection: string;
	categorieLieu: CategorieLieuType;
	vaccin: VaccinType;
	horodateEnregistrementMaj: string | undefined;
	horodatageEnregistrement: string | undefined;
	topEnregistrementMaj: boolean;
	injectionSupplementaire: boolean;
	motifInjectionSupp: MotifInjectionSupp | null;
	psDelegation: Ps | null;
}

export interface VaccinsContreIndiquesType {
	vaccinsContreIndiquesId: number | undefined;
	prescriptionId: number | undefined;
	vaccinId: number | undefined;
	vaccin: VaccinType;
}

export interface VaccinsPrescritsType {
	vaccinsPrescritsId: number | undefined;
	prescriptionId: number | undefined;
	vaccinId: number | undefined;
	vaccin: VaccinType;
}

export interface VaccinType {
	vaccinId: number;
	nom: string;
	voieAdministration: string;
	nbInjections: number;
	dureeEntreInjections: number;
	descriptif: string;
	actif: boolean;
	dateDebutValidite: string;
	dateFinValidite: string;
	margeInjection: number;
	nomLong: string;
	lots: LotType[];
}

export interface LotType {
	lotId?: number;
	numeroLot?: string;
	autreLot?: boolean;
	datePeremption?: string;
}

export interface LieuType {
	lieuId: number;
	libelle: string;
	finess: string;
	siret: string;
	categorieLieu: CategorieLieuType;
}

export interface CategorieLieuType {
	categorieLieuId: number;
	libelle: string;
}

export interface Folder {
	numeroBon: string;
	nirAssure: string;
	nirBeneficiaire: string;
	dateNaissanceBeneficiaire: string;
	rangBeneficiaire: string;
	dateEnvoiInvitationPrescription: string;
	nomBeneficiaire: string;
	nomPatronymiqueAssure: string;
	nomPatronymiqueBeneficiaire: string;
	prenomBeneficiaire: string;
	sexeBeneficiaire: string;
	codePostal: string;
	adresseL1?: string;
	adresseL2?: string;
	adresseL3?: string;
	adresseL4?: string;
	adresseL5?: string;
	adresseL6?: string;
	telephonePortable?: string;
	bureauDistributeur?: string;
	qualiteAyantDroit: string;
	email: string;
	codeCiblage: string;
	codeGrandRegime: string;
	caisseRattachement: string;
	centreRattachement: string;
	libelleRegime: string;
	acronymeRegime: string;
	libelleCaisse: string;
	cleBeneficiaire: string;
	cleAssure: string;
	idBeneficiaire: string;
	nomAssure: string;
	prenomAssure: string;
	civiliteAssure: string;
	civiliteBeneficiaire: string;
	npai: boolean;
	prescription: PrescriptionType;
	degrade: boolean;
}

export class VaccinationFolder {
	numeroBon: string | undefined;
	nirAssure: string;
	nirBeneficiaire: string;
	dateNaissanceBeneficiaire: string;
	rangBeneficiaire: string;
	dateEnvoiInvitationPrescription: string;
	nomBeneficiaire: string;
	nomPatronymiqueBeneficiaire: string;
	nomPatronymiqueAssure: string;
	prenomBeneficiaire: string;
	sexeBeneficiaire: string;
	codePostal?: string;
	adresseL1?: string;
	adresseL2?: string;
	adresseL3?: string;
	adresseL4?: string;
	adresseL5?: string;
	adresseL6?: string;
	telephonePortable?: string;
	bureauDistributeur?: string;
	qualiteAyantDroit: string;
	email?: string;
	codeCiblage?: string;
	codeGrandRegime: string;
	caisseRattachement: string;
	centreRattachement: string;
	libelleRegime: string;
	acronymeRegime: string;
	libelleCaisse: string;
	cleBeneficiaire: string;
	cleAssure: string;
	idBeneficiaire: string;
	nomAssure: string;
	prenomAssure: string;
	civiliteAssure: string;
	civiliteBeneficiaire: string;
	npai: boolean;
	degrade?: boolean;
	prescription?: PrescriptionType;

	constructor(data: { dossier: Folder }) {
		this.numeroBon = data.dossier.numeroBon;
		this.nirAssure = data.dossier.nirAssure;
		this.nomPatronymiqueAssure = data.dossier.nomPatronymiqueAssure;
		this.nirBeneficiaire = data.dossier.nirBeneficiaire;
		this.dateNaissanceBeneficiaire = data.dossier.dateNaissanceBeneficiaire;
		this.rangBeneficiaire = data.dossier.rangBeneficiaire;
		this.dateEnvoiInvitationPrescription = data.dossier.dateEnvoiInvitationPrescription;
		this.nomBeneficiaire = data.dossier.nomBeneficiaire;
		this.nomPatronymiqueBeneficiaire = data.dossier.nomPatronymiqueBeneficiaire;
		this.prenomBeneficiaire = data.dossier.prenomBeneficiaire;
		this.sexeBeneficiaire = data.dossier.sexeBeneficiaire;
		this.codePostal = data.dossier.codePostal;
		this.adresseL1 = data.dossier.adresseL1;
		this.adresseL2 = data.dossier.adresseL2;
		this.adresseL3 = data.dossier.adresseL3;
		this.adresseL4 = data.dossier.adresseL4;
		this.adresseL5 = data.dossier.adresseL5;
		this.adresseL6 = data.dossier.adresseL6;
		this.telephonePortable = data.dossier.telephonePortable;
		this.bureauDistributeur = data.dossier.bureauDistributeur;
		this.qualiteAyantDroit = data.dossier.qualiteAyantDroit;
		this.email = data.dossier.email;
		this.codeCiblage = data.dossier.codeCiblage;
		this.codeGrandRegime = data.dossier.codeGrandRegime;
		this.caisseRattachement = data.dossier.caisseRattachement;
		this.centreRattachement = data.dossier.centreRattachement;
		this.libelleRegime = data.dossier.libelleRegime;
		this.acronymeRegime = data.dossier.acronymeRegime;
		this.libelleCaisse = data.dossier.libelleCaisse;
		this.prescription = data.dossier.prescription;
		this.cleAssure = data.dossier.cleAssure;
		this.cleBeneficiaire = data.dossier.cleBeneficiaire;
		this.idBeneficiaire = data.dossier.idBeneficiaire;
		this.nomAssure = data.dossier.nomAssure;
		this.prenomAssure = data.dossier.prenomAssure;
		this.civiliteAssure = data.dossier.civiliteAssure;
		this.civiliteBeneficiaire = data.dossier.civiliteBeneficiaire;
		this.npai = data.dossier.npai;
		this.degrade = data.dossier.degrade;
	}
}

export interface VaccinationFolderState {
	vaccinationFolder?: VaccinationFolder;
	attestation?: boolean;
	deletion?: boolean;
	additionnalInjection?: number;
	lastCycle?: boolean;
	error: boolean;
	cancellation?: boolean;
	folderUpdateDisplay?: boolean;
	folderUpdateAvailable?: boolean;
	isRecapitulatif?: boolean;
	reactivationAvailable?: boolean;
}

export interface FolderUpdate {
	nomAssure: string | undefined;
	prenomAssure: string | undefined;
	nomPatronymiqueAssure: string | undefined;
	nomBeneficiaire: string | undefined;
	prenomBeneficiaire: string | undefined;
	nomPatronymiqueBeneficiaire: string | undefined;
	dateNaissanceBeneficiaire: string | undefined;
	rangBeneficiaire: string | undefined;
	sexeBeneficiaire: string | undefined;
}
